/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Grid from '@mui/material/Grid';
import { Autocomplete, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import type { ApiResponse, appConfigs, RootState } from '../types/types';
import { getAllCampaigns } from 'src/services/campaignService';
import { CAMPAIGN_START_DATE, CAMPAIGN_END_DATE, BRANDNAME, CAMPAIGN_Group, EMAIL_TEMPLATE, TRIGGER_CAMPAIGN_ERROR, TRIGGER_NAME_ERROR, TRIGGER_STARTDATE_ERROR, VALID_TRIGGER_NAME_ERROR } from 'src/constants/constant';
import { NotificationManager } from 'react-notifications';
import { HugeiconsIcon } from '@hugeicons/react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import {ViewStrokeRounded,Image03Icon, Calendar03Icon} from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import TemplatePreview from '../TemplatePreview/TemplatePreview';


export interface CampaignDetails {
    endOn: string;
    brandName: string;
    groupName: string;
    templateName: string;
    templateContent?: string;
    templateIdentifier?:string;
    name?: string;
    campaignId?: string;
    startOn: string;
}

export interface TriggerFormData {
    triggername: string;
    campaignId: string;
    startOn: string;
    triggerenddate?: string;
}

interface ScheduleTriggerProps {
    onFormValidation: (isValid: boolean) => void;
    onDataSubmit: (data: TriggerFormData) => void;
    submitAttempted?: boolean; // New prop to handle submission attempt
}

const validationSchema = Yup.object().shape({
    triggername: Yup.string()
        .trim()
        .required(TRIGGER_NAME_ERROR)
        .matches(
            /^(?!\s*$)[a-zA-Z0-9\s.,]+(?:[-'][a-zA-Z0-9\s.,]+)*$/,
            VALID_TRIGGER_NAME_ERROR
        ),
    campaignId: Yup.string().required(TRIGGER_CAMPAIGN_ERROR),
    startOn: Yup.string().required(TRIGGER_STARTDATE_ERROR)
});

const ScheduleTrigger: React.FC<ScheduleTriggerProps> = ({ 
    onFormValidation, 
    onDataSubmit, 
    submitAttempted = false 
}) => {
    const [campaigns, setCampaigns] = useState<CampaignDetails[]>([]);
    const [selectedCampaignDetails, setSelectedCampaignDetails] = useState<CampaignDetails | null>(null);
    const { user } = useSelector((state: RootState) => state.auth);
    const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
    const storedAppConfig = localStorage.getItem("appConfigs");
    const [dailyMaxSendCount, setDailyMaxSendCount] = useState<number>(0);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const totalNpiRecords = Number(sessionStorage.getItem("totalNpiRecords")) || 0; 
    const [selectedTemplate, setSelectedTemplate] = useState<CampaignDetails | null>(null);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const parsedAppConfig = storedAppConfig 
    ? (JSON.parse(storedAppConfig) as appConfigs[]) 
    : [];

    const TemplateImagePublicURL = parsedAppConfig.find(
    (item) => item.configName === "TemplateImagePublicURL"
    )?.configValue;

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (storedAppConfig) {
            try {
                const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];

                const dailyLimit = parsedAppConfig.find(item => item.configName === "DailyMaxSendCount")?.configValue;
                console.log(dailyLimit);
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                setDailyMaxSendCount(Number(dailyLimit) || 0);
            } catch (error) {
                console.error("Error parsing appConfigs:", error);
            }
        }
    }, []);

        const {
        control,
        formState: { errors, isValid },
        setValue,
        watch,
        trigger: triggerValidation,
        handleSubmit
    } = useForm<TriggerFormData>({
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
        defaultValues: {
            triggername: '',
            campaignId: '',
            startOn: '',
        }
    });

    // Watch value updates
    const triggerEndDate = watch("triggerenddate"); 

    useEffect(() => {
        void getCampaignListData();
    }, []);

    // Effect to handle form validation status
    useEffect(() => {
        console.log(isValid);
        onFormValidation(isValid);
    }, [isValid, onFormValidation]);

    const getCampaignListData = async (): Promise<void> => {
        try {
            const ClientId = user?.clientId ?? 0;
            const res: ApiResponse = await getAllCampaigns(ClientId);
            if (res.status === 200) {
                const templateArr = res.data.data
                .filter((template: any) => template.isActive === true && template.isDeleted === false && template.startOn !== null && template.endOn !== null)
                .map((template: any) :any=> ({
                    ...template,
                    name: template.name,
                    id: template.campaignId,
                    startOn: template.startOn,  
                    endOn: template.endOn,      
                }));
                setCampaigns(templateArr as CampaignDetails[]);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    // Handle form submission
    const onSubmit = async (data: TriggerFormData): Promise<void> => {

        // Validate campaign expiration
        if (selectedCampaignDetails && moment(selectedCampaignDetails.endOn).isBefore(moment(), "day")) {
            NotificationManager.error("Cannot create a trigger for an expired campaign");
            return;
        }

        // Ensure start and end dates fall within campaign range
        if (
            moment(data.startOn).isBefore(moment(selectedCampaignDetails?.startOn), "day") ||
            moment(data.triggerenddate).isAfter(moment(selectedCampaignDetails?.endOn), "day")
        ) {
            NotificationManager.error("Trigger dates must be within the selected campaign dates");
            return;
        }
        setHasAttemptedSubmit(true);
        const isValidForm = await triggerValidation();
        
        if (isValidForm) {
            onDataSubmit(data);
            // Reset the attempt flags after successful submission
            setHasAttemptedSubmit(false);
        }
       
    };
    console.log(submitAttempted);
    // Trigger validation manually when submitAttempted changes
    useEffect(() => {
        if (submitAttempted) {
            void handleSubmit(onSubmit)();
        }
    }, [submitAttempted]);
    useEffect(() => {
        if (isValid && hasAttemptedSubmit) {
            setHasAttemptedSubmit(false);
        }
    }, [isValid]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
            <Grid item xs={8} sx={{ paddingRight: '20px' }}>
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    height: '100%'
                }}>
                    {/* Main content container */}
                    <div style={{ flex: 1, overflowY: 'auto' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <div className="mb-[30px] mt-4">
                                    <Controller
                                        name="triggername"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                autoComplete="off"
                                                label="List Trigger Name *"
                                                error={Boolean(errors.triggername)}
                                                helperText={errors.triggername?.message}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: errors.triggername && 'red',
                                                        },
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="campaignId"
                                        control={control}
                                        render={({ field }) => (
                                            <Autocomplete
                                                options={campaigns}
                                                getOptionLabel={(option: any) => option.name}
                                                popupIcon={
                                                    <HugeiconsIcon
                                                        icon={ArrowDown01Icon}
                                                        size={18}
                                                        color="#3A3A3A"
                                                        strokeWidth={0.2}

                                                    />
                                                }
                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                 //@ts-ignore
                                                isOptionEqualToValue={(option, value) => option.campaignId === value}
                                                value={campaigns.find(campaign => campaign.campaignId === field.value)}
                                                onChange={(_, selectedOption) => {
                                                    field.onChange(selectedOption?.campaignId);
                                                    setSelectedCampaignDetails(selectedOption);
                                                    setSelectedTemplate(selectedOption);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Campaign *"
                                                        placeholder="Select Campaign"
                                                        error={Boolean(errors.campaignId)}
                                                        helperText={errors.campaignId?.message}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                </div>
                            </Grid>
                        </Grid>

                        {selectedCampaignDetails && (
                            <Grid container spacing={2}>
                                <Grid item xs={12} sx={{ paddingTop: '0px', marginLeft: '16px' }}>
                                    <div className="campaign-details">
                                        <p className='text-muted' style={{
                                            marginBottom: '12px',
                                        }}><strong className='font-semibold'>{CAMPAIGN_START_DATE} : </strong> {moment(selectedCampaignDetails.startOn).format('MM/DD/YYYY')}</p>
                                        <p className='text-muted' style={{
                                            marginBottom: '12px',
                                        }}><strong className='font-semibold'>{CAMPAIGN_END_DATE} : </strong> {moment(selectedCampaignDetails.endOn).format('MM/DD/YYYY')}</p>
                                        <p className='text-muted' style={{
                                            marginBottom: '12px',
                                        }}><strong className='font-semibold'>{BRANDNAME} : </strong> {selectedCampaignDetails.brandName}</p>
                                        <p className='text-muted' style={{
                                            marginBottom: '12px',
                                        }}><strong className='font-semibold'>{CAMPAIGN_Group} : </strong> {selectedCampaignDetails.groupName}</p>
                                        <p className='text-muted' style={{
                                            marginBottom: '12px',
                                        }}><strong className='font-semibold'>{EMAIL_TEMPLATE} : </strong> {selectedCampaignDetails.templateName}</p>
                                    </div>
                                </Grid>
                            </Grid>
                        )}
                    </div>

                    {/* Fixed date fields at bottom */}
                    <div style={{ 
                        marginTop: 'auto', 
                        borderTop: '1px solid #D3D3D3',
                        paddingTop: '20px'
                    }}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="startOn"
                                        control={control}
                                        render={({ field }) => (
                                            <div className='datepicker-container'>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DemoContainer components={['DatePicker']}>
                                                        <DatePicker
                                                            label="Trigger Start Date *"
                                                            onChange={(newValue) => {
                                                                const formattedDate = moment(newValue).format('MM/DD/YYYY');
                                                                field.onChange(formattedDate);
                        
                                                                // Calculate End Date on Change
                                                                if (dailyMaxSendCount > 0 && totalNpiRecords > 0) {
                                                                    let daysNeeded =totalNpiRecords / dailyMaxSendCount;
                                                                    if (daysNeeded < 1) {
                                                                        daysNeeded = 0;
                                                                    }
                                                                    else{
                                                                        daysNeeded = Math.ceil(daysNeeded);
                                                                    }
                                                                    const endDate = moment(formattedDate, "MM/DD/YYYY").add(daysNeeded, "days").format("MM/DD/YYYY");
                                                                    setValue("triggerenddate", endDate);
                                                                }
                                                            }}
                                                            minDate={moment()}
                                                            slotProps={{
                                                                textField: {
                                                                    error: Boolean(errors.startOn),
                                                                    helperText: errors.startOn?.message,
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-root': {
                                                                            '& fieldset': {
                                                                                borderColor: errors.startOn  && 'red',
                                                                            },
                                                                        },
                                                                    }
                                                                }
                                                            }}
                                                            slots={{
                                                                openPickerIcon: () => (
                                                                    <HugeiconsIcon
                                                                        icon={Calendar03Icon}
                                                                        size={18}
                                                                        color="#3A3A3A"
                                                                        strokeWidth={0.2}
                                                                    />
                                                                )
                                                            }}
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </div>
                                        )}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <div>
                                    <Controller
                                        name="triggerenddate"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                autoComplete="off"
                                                label="Trigger End Date"
                                                disabled
                                                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                                value={triggerEndDate ? moment(triggerEndDate).format("MM/DD/YYYY") : ""}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder="Trigger End Date"
                                            />
                                        )}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </Grid>

            <Grid item xs={4} sx={{ paddingRight: '20px' }}>
                <div className="flex justify-between mb-[10px] mt-[10px]">
                    <div className="text-16 font-semibold text-muted">Template Preview</div>
                </div>
                <div className="relative cursor-pointer flex justify-center items-center h-[316px] border border-[#e6ecf2] rounded-lg">
                    {/* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */}
                    {selectedTemplate?.templateIdentifier ? (
                        <img 
                            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                            src={`${TemplateImagePublicURL}Template/${selectedTemplate.templateIdentifier}/Template_Large.png`}
                            alt="Template Preview"
                            className="icon-hover"
                            onError={(e) => (e.target as HTMLImageElement).style.display = 'none'} // Hide if image fails
                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                        />
                    ) : (
                        <HugeiconsIcon
                            icon={Image03Icon}
                            size={50}
                            color="#6B7280"
                            className="block"
                        />
                    )}

                    {/* Hover View Icon */}
                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg hover:opacity-100 transition-opacity cursor-pointer" onClick={selectedTemplate?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}>
                        <HugeiconsIcon
                            icon={ViewStrokeRounded}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                            className={`cursor-pointer text-white ${
                                selectedTemplate?.templateContent !== undefined && selectedTemplate?.templateContent !== null && selectedTemplate?.templateContent !== ''
                                    ? ''
                                    : 'opacity-50 cursor-not-allowed'
                            }`}
                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                            onClick={selectedTemplate?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}
                            
                        />
                    </div>
                </div>
            </Grid>
            <TemplatePreview 
                isOpen={isPreviewModalOpen} 
                onClose={() => setIsPreviewModalOpen(false)} 
                content={selectedTemplate?.templateContent ?? ''}
            />
        </Grid>
        </form>
    );
};

export default ScheduleTrigger;